export const balanceChartOption = {
  chart: {
    type: 'pie',
    spacing: [0, 0, 0, 0] // 👈 bỏ padding mặc định
  },
  title: { text: null },
  subtitle: { text: null },
  credits: { enabled: false },

  tooltip: {
    enabled: false
  },

  plotOptions: {
    pie: {
      startAngle: 180,
      size: '100%',        // 👈 fit full container
      center: ['50%', '50%'], // 👈 luôn nằm giữa
      allowPointSelect: false,
      cursor: 'pointer',
      states: {
        hover: { enabled: false },
        inactive: {
            enabled: false,
            opacity: 1
        }
      },
      dataLabels: {
        enabled: false
      }
    }
  },

  series: [{
    name: 'Balance',
    colorByPoint: true,
    data: []
  }]
}